<template>
  <div>
    <div
      class="mov_iphone1"
      :style="{ height: radioBtnChoice == 2 ? '750px' : '700px' }"
    >
      <div class="mov_time">
        <p>{{ phoneTime }}</p>
      </div>
      <div class="mov_notch"></div>
      <div class="mov_icons">
        <img
          src="https://img.icons8.com/?size=100&id=XDb82AbsXTbs&format=png&color=FFFFFF"
          alt=""
        />
        <img
          src="https://img.icons8.com/?size=100&id=89396&format=png&color=FFFFFF"
          alt=""
        />
        <img
          src="https://img.icons8.com/?size=100&id=8574&format=png&color=FFFFFF"
          alt=""
        />
      </div>
      <div class="mov_account">
        <div class="mov_acct mt-n6">
          <h1 class="mt-4">Credit Balance: {{ analytics.credits }}</h1>
        </div>
      </div>

      <!-- start of Analytics -->
      <div class="mov_new_released">
        <div class="mov_new_released_stack">
          <div class="mov_new_released_card">
            <h3>Sent</h3>
            <div class="card_rating">
              <p>{{ analytics.sent }}</p>
            </div>
          </div>
          <div class="mov_new_released_card">
            <h3>Delivered</h3>
            <div class="card_rating">
              <p>{{ analytics.delivered }}</p>
            </div>
          </div>
          <div class="mov_new_released_card">
            <h3>Rejected</h3>
            <div class="card_rating">
              <p>{{ analytics.rejected }}</p>
            </div>
          </div>
          <div class="mov_new_released_card">
            <h3>Scheduled</h3>
            <div class="card_rating">
              <p>{{ analytics.scheduled }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- End of Analytics -->

      <!-- Start of Numbers -->
      <div
        class="mov_popular_released mt-n8"
        v-if="recipientsObjArray.length < 1"
      >
        <h1>Numbers [Manual Entering]</h1>
        <div class="mov_new_released_stack">
          <v-textarea
            style="border-radius: 6px"
            :rows="1"
            background-color="grey lighten-3"
            placeholder="076 243 9441, 081 482 6615"
            label="Enter Numbers"
            :value="numbers"
            v-model="numbers"
          >
          </v-textarea>
        </div>
      </div>
      <!-- End of NUmbers -->

      <!-- Start of Selection -->
      <div class="mov_popular_released mt-n4">
        <h1>When To Send?</h1>
        <div class="mov_new_released_stack">
          <v-select
            dense
            style="border-radius: 6px"
            background-color="grey lighten-3"
            :items="whenToSend"
            filled
            label="Schedule"
            v-model="schedule"
            @change="determineSchedule"
          ></v-select>
        </div>
      </div>
      <!-- End of Selection -->

      <!-- Start of Message Title -->
      <div class="mov_popular_released mt-n6" v-if="showDateTime">
        <h1>Schedule Date & Time</h1>
        <div>
          <DateTimePicker
            @date-time-picked="getSelectedDateTime"
            :defaultDateTime="dateTime"
          ></DateTimePicker>
        </div>
      </div>
      <!-- End of Message Title -->

      <!-- Start of Predefine -->
      <div class="mov_popular_released mt-n10">
        <div>
          <v-radio-group row v-model="radioBtnChoice">
            <v-radio color="green" label="Custom SMS" :value="1" dark></v-radio>
            <v-radio
              color="green"
              label="Predefine SMS"
              :value="2"
              dark
            ></v-radio>
          </v-radio-group>
        </div>
        <!-- <h1>Numbers [Manual Entering]</h1>
        <div class="mov_new_released_stack">
          <v-textarea
            style="border-radius: 6px"
            :rows="1"
            background-color="grey lighten-3"
            placeholder="076 243 9441, 081 482 6615"
            label="Enter Numbers"
            :value="numbers"
            v-model="numbers"
          >
          </v-textarea>
        </div> -->
      </div>
      <!-- End of Predefine -->

      <div class="mov_popular_released mt-n6" v-if="radioBtnChoice == 1">
        <h1>Message Body</h1>
        <div class="mov_new_released_stack">
          <v-textarea
            style="border-radius: 6px"
            prepend-inner-icon="mdi-comment"
            :rows="showDateTime ? 5 : 7"
            background-color="grey lighten-3"
            counter
            placeholder="Type message here"
            label="Message"
            :rules="rules"
            :value="message"
            v-model="message"
          >
          </v-textarea>
        </div>
      </div>
      <div class="mov_popular_released mt-n6" v-else-if="radioBtnChoice == 2">
        <!-- Start of Predefined Selection -->
        <div class="mt-n4">
          <h1>Select Predefined SMS</h1>
          <div>
            <v-select
              dense
              style="border-radius: 6px"
              background-color="grey lighten-3"
              :items="allPredefinedSMSes"
              item-text="name"
              item-value="name"
              filled
              label="Select Predefined"
              v-model="selectedPredefinedSMS"
              @change="getSelectedPredefinedSMS"
              return-object
            ></v-select>
          </div>
        </div>
        <!-- End of Predefined Selection -->

        <div class="mov_new_released_stack" v-if="selectedPredefinedSMS">
          <v-textarea
            style="border-radius: 6px"
            prepend-inner-icon="mdi-comment"
            :rows="showDateTime ? 5 : 7"
            background-color="grey lighten-3"
            counter
            placeholder="Type message here"
            label="Message"
            :rules="
              radioBtnChoice == 2 &&
              selectedPredefinedSMS &&
              selectedPredefinedSMS.name == 'Student Statements via SMS'
                ? []
                : rules
            "
            :value="message"
            v-model="message"
          >
          </v-textarea>
        </div>
      </div>
      <div class="mov_docker" :style="{ 'background-color': getThemeColor }">
        <div class="mov_dock_icons">
          <div class="icon_sep">
            <img
              src="https://img.icons8.com/material/512/home-page.png"
              alt=""
            />
            <img src="https://img.icons8.com/material/512/hearts.png" alt="" />
          </div>
          <div class="icon_sep">
            <img
              src="https://img.icons8.com/material/512/cinema---v2.png"
              alt=""
            />
            <img
              src="https://img.icons8.com/material/512/gender-neutral-user.png"
              alt=""
            />
          </div>
        </div>
        <div class="mov_search_btn" @click="sendSMS">
          <img
            src="https://img.icons8.com/?size=100&id=45729&format=png&color=000000"
            alt=""
          />
        </div>
        <div class="mov_dock_bar"></div>
      </div>
    </div>
    <div>
      <v-btn
        class="my-6"
        x-large
        dark
        block
        rounded
        @click="openSMSTopUpDialog()"
        :color="getThemeColor"
        >Top Up SMS Credit</v-btn
      >
    </div>

    <GlobalDialogSlot
      :title="dialogTitle"
      :dialog="dialog"
      @close-dialog="closeDialog"
      :maxWidth="maxWidth"
    >
      <div v-if="dialogContext == 'top-up-sms-credit'">
        <TopUpSMSCredits></TopUpSMSCredits>
      </div>
    </GlobalDialogSlot>
  </div>
</template>

<script>
import smsJs from "@/plugins/sms";
import DateTimePicker from "@/components/myLibrary/DateTimePicker.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";
import TopUpSMSCredits from "@/modules/BulkSMS/TopUpSMSCredits.vue";

export default {
  components: { DateTimePicker, GlobalDialogSlot, TopUpSMSCredits },
  props: {
    recipientsObjArray: {
      //name,phone,email,id,table,sid or staff_id,id_number
      default: () => [],
    },
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getSendSMSCGPTRoute() {
      return this.$store.getters.getSendSMSCGPTRoute;
    },
    getSMSAnalyticsRoute() {
      return this.$store.getters.getSMSAnalyticsRoute;
    },
    getAllPredefinedSMSesRoute() {
      return this.$store.getters.getAllPredefinedSMSesRoute;
    },
  },
  async created() {
    await this.getSMSAnalytics();
    await this.getAllPredefinedSMSes();
  },
  data: () => ({
    //sms top up
    dialog: false,
    dialogContext: "top-up-sms-credit",
    maxWidth: "800",
    dialogTitle: "Top Up SMS Credits",

    radioBtnChoice: 1,
    selectedPredefinedSMS: null,
    showDateTime: false,
    dateTime:
      new Date().toJSON().substring(0, 10) +
      " " +
      new Date().toLocaleTimeString(),
    analytics: {
      credits: 0,
      sent: 0,
      delivered: 0,
      rejected: 0,
      scheduled: 0,
    },
    phoneTime: new Date().toLocaleTimeString().substring(0, 5),
    rules: [(v) => v.length <= 230 || "Max 230 characters"],
    title: "",
    message: "",
    numbers: "",
    numbersCount: 100000000,
    numbersArray: [],
    schedule: "Now",
    whenToSend: ["Now", "Specified Day & Time", "Daily", "Weekly", "Monthly"],
    allPredefinedSMSes: [],
  }),
  methods: {
    async getSMSAnalytics() {
      this.$store.commit("setLoader", true);
      const analytics = await smsJs.getSMSAnalytics(
        this.getApiUrl + this.getSMSAnalyticsRoute
      );
      if (analytics) {
        this.analytics = analytics;
      }
      this.$store.commit("setLoader", false);
    },
    async getAllPredefinedSMSes() {
      this.$store.commit("setLoader", true);
      this.allPredefinedSMSes = await smsJs.getAllPredefinedSMSes(
        this.getApiUrl + this.getAllPredefinedSMSesRoute
      );
      this.$store.commit("setLoader", false);
    },
    getSelectedPredefinedSMS() {
      this.message = this.selectedPredefinedSMS.message;
    },
    async sendSMS() {
      //check message length
      if (!this.checkedMessageLength(this.message)) {
        return false;
      }
      //format numbers and count total numbers
      const numbers = this.formatNumbersToArray(this.numbers);

      //check if credits is enough
      if (!this.enoughCreditsForSendingSMS(this.message, this.numbersCount)) {
        return false;
      }

      if (
        this.schedule != "Now" &&
        this.schedule != "Specified Day & Time" &&
        this.analytics.credits &&
        Number(this.analytics.credits) < 3500
      ) {
        this.$toast.warning(
          "Not Enough SMS Credits To Schedule " +
            this.schedule +
            " Recurring SMS!"
        );
        return false;
      }

      this.$store.commit("setLoader", true);

      const messages = await smsJs.sendSMS(
        this.getApiUrl + this.getSendSMSCGPTRoute,
        this.message,
        this.schedule,
        this.dateTime,
        numbers,
        this.radioBtnChoice,
        this.selectedPredefinedSMS
      );

      this.$store.commit("setLoader", false);
      if (this.schedule == "Now") {
        this.$toast.success("SMS Sent Successfully!", { duration: 4000 });
      } else {
        this.$toast.success("SMS Scheduled Successfully!", { duration: 4000 });
      }
    },
    formatNumbersToArray(numbers) {
      if (this.recipientsObjArray.length > 0) {
        this.numbersCount = 0;
        const recipients = [...this.recipientsObjArray];
        recipients.forEach((recipient) => {
          if (typeof recipient.phone == "object") {
            this.numbersCount += Number(recipient.phone.length);
          } else {
            recipient.phone = this.splitNumberToArray(recipient.phone);
            this.numbersCount += Number(recipient.phone.length);
          }
        });
        return recipients;
      }

      if (typeof numbers == "object") {
        this.numbersCount = numbers.length;
        return numbers;
      } else {
        const nums = this.splitNumberToArray(numbers);
        this.numbersCount = nums.length;
        return nums;
      }
    },
    enoughCreditsForSendingSMS(message, numbersCount = 10000) {
      if (message && message.length > 0) {
        let msg = 100000000;
        if (message.length <= 160) {
          msg = 1;
        } else if (message.length > 160 && message.length < 231) {
          msg = 2;
        } else if (
          message.length > 230 &&
          this.radioBtnChoice == 2 &&
          this.selectedPredefinedSMS &&
          this.selectedPredefinedSMS.name == "Student Statements via SMS"
        ) {
          msg = 3;
        } else {
          this.$toast.error("Not Enough Credits!", {
            duration: 4000,
          });
          return false;
        }

        //Now calculate totals
        if (
          this.analytics.credits &&
          Number(this.analytics.credits) >=
            (Number(msg) * Number(numbersCount)).toFixed(0)
        ) {
          return true;
        } else {
          this.$toast.error("Not Enough Credits!", {
            duration: 4000,
          });
          return false;
        }
      } else {
        this.$toast.error("SMS Body Cannot Be Empty 230!", {
          duration: 4000,
        });
        return false;
      }
    },
    checkedMessageLength(message) {
      if (message && message.length > 230) {
        if (
          this.radioBtnChoice == 2 &&
          this.selectedPredefinedSMS &&
          this.selectedPredefinedSMS.name == "Student Statements via SMS"
        ) {
          return true;
        } else {
          this.$toast.error("SMS Cannot Be More Than 230 Characters!", {
            duration: 4000,
          });
          return false;
        }
        this.$toast.error("SMS Cannot Be More Than 230 Characters!", {
          duration: 4000,
        });
        return false;
      } else {
        return true;
      }
    },
    getSelectedDateTime(dateTime) {
      this.dateTime = dateTime;
    },
    openSMSTopUpDialog() {
      if (!this.isAdmin) {
        this.$toast.error("You Do Not Have The Right Permissions!", {
          duration: 5000,
        });
        return false;
      }
      this.dialog = true;
      this.dialogContext = "top-up-sms-credit";
      this.maxWidth = "800";
      this.dialogTitle = "Top Up SMS Credits";
    },
    closeDialog() {
      this.dialog = false;
      this.dialogContext = null;
      this.dialogTitle = null;
      this.SASAMSStudentsData = [];
    },
    determineSchedule() {
      if (this.schedule != "Now") {
        this.showDateTime = true;
      } else {
        this.showDateTime = false;
      }
    },
    splitNumberToArray(number) {
      if (!number) {
        return [];
      }
      const delimiters = /[,;|\/]/;
      let nums = number.split(delimiters);
      const newArr = [...nums];
      nums = [];
      newArr.forEach((num) => {
        nums.push(num.replace(/\s/g, ""));
      });
      return nums;
    },
  },
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap");

* {
  padding: 0;
  border: 0;
  margin: 0;
  box-sizing: border-box;
}

.mov_main {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 1300px;
  max-height: 800px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 80px;
}

.mov_iphone1 {
  position: relative;
  max-width: 390px;
  // height: 700px;
  background: linear-gradient(180deg, #403c37 0%, #000 67.71%);
  border: 7.1817px solid #000000;
  box-shadow: 0px 7.71602px 15.432px rgba(0, 0, 0, 0.55);
  border-radius: 45px;
  overflow: hidden;
}

.mov_time {
  position: absolute;
  top: 15px;
  left: 20px;
}

.mov_time p {
  font-weight: 700;
  font-size: 15px;
  color: #fff;
}

.mov_notch {
  position: absolute;
  top: 10px;
  left: 110px;
  width: 105px;
  height: 30px;
  background: #000000;
  border-radius: 30.8641px;
}

.mov_icons {
  position: absolute;
  top: 15px;
  right: 30px;
  display: flex;
  gap: 7px;
}

.mov_icons img {
  width: 18px;
}

/* ______________________________________ */

.mov_account {
  margin-top: 50px;
  padding: 0 20px;
}

.mov_acct {
  display: flex;
  gap: 10px;
  align-items: center;
}

.mov_acct img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  object-fit: cover;
  filter: drop-shadow(0px 3.08641px 3.08641px rgba(0, 0, 0, 0.4));
}

.mov_acct h1 {
  font-size: 23px;
  color: #fff;
}

/* ______________________________________ */

.mov_search {
  display: flex;
  margin-top: 13px;
  padding: 0 20px;
  justify-content: space-between;
  align-items: center;
}

.search_bar {
  background-color: #fff;
  width: 300px;
  height: 41px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  box-shadow: 0px 3.08641px 3.08641px rgba(0, 0, 0, 0.25);
}

.search_bar p {
  font-size: 13px;
  padding-left: 10px;
}

.search_btn {
  width: 35px;
  height: 35px;
  background-color: #000;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 3.08641px 3.08641px rgba(0, 0, 0, 0.25);
}

.search_btn img {
  width: 20px;
}

/* ______________________________________ */

.mov_new_released {
  margin-top: 20px;
  padding: 0 10px;
}

.mov_new_released h1 {
  color: rgb(51, 43, 120);
  font-size: 20px;
  margin-bottom: 5px;
}

.mov_new_released_stack {
  display: flex;
  gap: 15px;
  overflow-x: scroll;
  cursor: pointer;
}
.mov_new_released_stack::-webkit-scrollbar {
  width: 0px;
}

.mov_new_released_card {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mov_new_released_card h3 {
  color: rgb(255, 255, 255);
  font-size: 14px;
}

.card_image {
  width: 80px;
  height: 100px;
  background-color: rgb(147, 147, 147);
  border-radius: 10px;
  margin-bottom: 5px;
  border-radius: 10px;
}

.card_image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.card_rating {
  display: flex;
  align-items: center;
  gap: 2px;
  color: #2e5ea2;
  margin-top: 2px;
}

.card_rating p {
  font-size: 14px;
  color: rgb(255, 255, 255);
}

.card_rating img {
  width: 13px;
}
/* ______________________________________ */

.mov_popular_released {
  margin-top: 0px;
  padding: 0 10px;
}

.mov_popular_released h1 {
  color: rgb(223, 223, 223);
  font-size: 16px;
  margin-bottom: 5px;
}

/* ______________________________________ */

.mov_docker {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 80px;
  background-color: #0174b2;
}

.mov_dock_icons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 100px;
  margin-top: 10px;
}

.icon_sep {
  display: flex;
  align-items: center;
  gap: 30px;
}

.icon_sep img {
  width: 30px;
  transition: all 0.3s;
}

.icon_sep img:hover {
  cursor: pointer;
  scale: 1.2;
  opacity: 0.6;
}

.mov_search_btn {
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background-color: #fff;
  border-radius: 50%;
  transition: all 0.3s;
}

.mov_search_btn img {
  width: 35px;
  height: 35px;
  margin-top: 13px;
  margin-left: 13px;
}

.mov_search_btn:hover {
  opacity: 0.6;
  top: 15%;
  cursor: pointer;
}

.mov_dock_bar {
  position: absolute;
  bottom: 5%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 2.31481px solid #000000;
  width: 130px;
  border-radius: 50px;
}

/* ______________________________________ */

.spiderman {
  position: absolute;
  top: 26%;
  left: 52%;
  transform: translate(-50%, -50%);
  z-index: 99;
  width: 430px;
  filter: contrast(1.3);
}

.mov_trailer_btn {
  position: absolute;
  top: 43%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(
    180deg,
    #a40000 35.94%,
    rgba(164, 0, 0, 0.3) 100%
  );
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.mov_trailer_btn img {
  width: 55px;
  margin-top: 3px;
  margin-left: 3px;
}

.watch_trailer {
  position: absolute;
  top: 51%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-weight: 500;
}

.mov_trailer_line {
  position: absolute;
  top: 54%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 200px;
  height: 4px;
  background: linear-gradient(
    90deg,
    rgba(187, 1, 1, 0) 15.1%,
    #bb0101 50%,
    rgba(187, 1, 1, 0) 85.94%
  );
}

.mov_trailer_title {
  position: absolute;
  top: 59%;
  left: 52%;
  transform: translate(-50%, -50%);
  color: #fff;
  width: 180px;
  font-size: 30px;
}

.mov_trailer_about {
  position: absolute;
  top: 64%;
  left: 72%;
  transform: translate(-50%, -50%);
  color: #9b9b9b;
  width: 100%;
  font-size: 12px;
}

.mov_trailer_rating {
  position: absolute;
  top: 68%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
}

.mov_trailer_rating img {
  width: 16px;
}

.mov_trailer_story {
  position: absolute;
  top: 78%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mov_trailer_story h2 {
  font-size: 15px;
  color: #fff;
}

.mov_trailer_story p {
  font-size: 12px;
  color: #9b9b9b;
  line-height: 16px;
}

/* ______________________________________ */

.mov_seating_status {
  display: flex;
  margin-top: 50px;
  padding: 0 30px;
  justify-content: space-between;
  align-items: center;
}

.mov_seating_status h1 {
  font-size: 20px;
  flex: 1;
  margin-left: 45px;
  color: rgb(223, 223, 223);
}

.seating_btn {
  width: 35px;
  height: 35px;
  background-color: #000;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 3.08641px 3.08641px rgba(0, 0, 0, 0.25);
}

.seating_btn img {
  width: 20px;
}

.mov_seating_dates {
  margin-top: 15px;
  padding: 0 10px;
  display: flex;
  gap: 10px;
  overflow-x: scroll;
}

.mov_seating_dates::-webkit-scrollbar {
  width: 0px;
}

.seating_date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 50px;
  height: 60px;
  background-color: rgb(0, 0, 0);
  border-radius: 10px;
  border: 1px solid #fff;
  transition: all 0.5s;
}

.seating_date h4,
p {
  color: #fff;
  font-size: 10px;
  padding: 0 20px;
}

.seating_date:hover {
  cursor: pointer;
  background-color: rgb(154, 0, 0);
}

/* ___________________________________________ */

.mov_seating_times {
  padding: 0 10px;
  display: flex;
  gap: 10px;
  overflow-x: scroll;
}

.mov_seating_times::-webkit-scrollbar {
  width: 0px;
}

.seating_time {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 100px;
  height: 30px;
  margin-bottom: 5px;
  background-color: rgb(0, 0, 0);
  border-radius: 50px;
  border: 1px solid #fff;
  transition: all 0.5s;
}

.seating_time p {
  color: #fff;
  font-size: 10px;
  padding: 0 20px;
  width: 85px;
}

.seating_time:hover {
  cursor: pointer;
  background-color: rgb(154, 0, 0);
}

.mov_seating_screen {
  width: 300px;
  height: 70px;
  margin: auto;
  border: 2px solid #fff;
  border-radius: 50%;
  border-left: none;
  border-right: none;
  border-bottom: none;
}

.mov_seating_screen p {
  text-align: center;
  margin-top: 20px;
}

.mov_seating_seats {
  width: 300px;
  height: 240px;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.row span {
  width: 15px;
  height: 15px;
  background-color: rgb(86, 86, 86);
  border-radius: 20%;
}

.row span:hover {
  cursor: pointer;
  background-color: rgb(255, 255, 255);
}

.mov_seating_options {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -20px;
}

.mov_seating_option {
  display: flex;
  align-items: center;
}

.mov_seating_option span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.mov_seating_option p {
  font-size: 12px;
  margin-left: -15px;
}

.mov_seating_docker {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 130px;
  border-radius: 30px;
  background-color: #b20101;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.mov_seating_docker_location {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -20px;
}

.mov_seating_docker_location img {
  width: 25px;
}

.mov_seating_docker_location h1 {
  color: #fff;
  font-size: 20px;
}

.mov_seating_docker p {
  font-size: 12px;
  text-align: center;
}

.mov_seating_checkout {
  width: 200px;
  height: 30px;
  background-color: #fff;
  border-radius: 50px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.3s;
}

.mov_seating_checkout p {
  color: #000;
  font-weight: 700;
}

.mov_seating_checkout:hover {
  cursor: pointer;
  background-color: #ffffffb9;
}
</style>
